import types from "../types"

/* Read */
export default function read(model, id) {
  return {
    type: types.read,
    model,
    id,
  }
}

read.success = function readSuccess(model, id, data) {
  return {
    type: types.readSuccess,
    id,
    model,
    data,
  }
}

read.error = function readError(model, id, error) {
  return {
    type: types.readError,
    model,
    id,
    error,
  }
}

read.cancel = function readError(model, id, reason = `No reason`) {
  return {
    type: types.readCancel,
    model,
    id,
    reason,
  }
}
